<template>

  <v-container class="py-4 ma-0 vehicle-status-manager" :class="vehicleStatus">
    <v-row class="py-3">
      <v-col cols="12" class="d-flex flex-column align-center py-0">

        <!-- Title and Current Status Info -->
        <div class="d-flex align-center justify-center" v-if="vehicleStatus === 'AT_HQ'">
          <v-icon style="font-size:30px;" class="mr-2" color="#FF9D29">mdi-check-bold</v-icon>
          <span class="action-title">Vehicle is Ready for Deliveries</span>
        </div>
        <div class="d-flex align-center justify-center" v-if="vehicleStatus === 'ON_DELIVERY'">
          <v-icon style="font-size:28px;" class="mr-4" color="#8DBF42">mdi-truck-fast</v-icon>
          <span class="action-title">Vehicle is on a Delivery</span>
        </div>
        <div class="d-flex align-center justify-center" v-if="vehicleStatus === 'RETURNING_TO_HQ'">
          <v-icon style="font-size:30px;" class="mr-2" color="#a1a1a1">mdi-clock-outline</v-icon>
          <span class="action-title">Vehicle Returning from Delivery</span>
        </div>
        <div class="d-flex align-center justify-center" v-if="vehicleStatus === 'IN_MAINTENANCE'">
          <v-icon style="font-size:30px;" class="mr-2" color="#FFD600">mdi-alert-circle-outline</v-icon>
          <span class="action-title">Vehicle in Maintenance</span>
        </div>
        <div class="d-flex align-center justify-center" v-if="vehicleStatus === 'RETIRED'">
          <v-icon style="font-size:30px;" class="mr-2" color="#FF5D67">mdi-alert-outline</v-icon>
          <span class="action-title">Vehicle is Retired</span>
        </div>

        <!-- Status Change Action -->
        <div class="d-flex align-center justify-center mt-4" v-if="availableStatusChangeOptions.length > 0 && canEdit">
          <v-select
              outlined
              hide-details
              :items="availableStatusChangeOptions"
              item-text="label"
              item-value="value"
              v-model="statusToUpdate" />
          <dialog-confirm-button
              :buttonText="(isProcessing) ? 'Updating...' : 'Change Status'"
              buttonColor="primary"
              buttonClass="ml-7"
              :disabled="isProcessing || !statusToUpdate"
              :message="confirmStatusChangeMessage"
              @confirmed="updateStatus" />
          <v-btn
              v-if="statusToUpdate"
              plain
              small
              color="primary"
              class="ml-3"
              @click="cancelStatusChange">
            Cancel
          </v-btn>
        </div>
        <div class="mt-5 action-info" v-if="statusToUpdate === 'AT_HQ'">Vehicle will be ready for delivery assignments.</div>
        <div class="mt-5 action-info" v-if="statusToUpdate === 'RETIRED'">Vehicle will be retired and no longer available for deliveries.</div>
        <div class="mt-5 action-info" v-if="statusToUpdate === 'IN_MAINTENANCE'">Vehicle will be unavailable for delivery assignments while in maintenance.</div>

      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import DialogConfirmButton from '@/components/app/DialogConfirmButton'

export default {
  name: 'VehicleStatusManager',

  components: {
    DialogConfirmButton
  },

  props: {
    vehicle: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isProcessing: false,
      processingError: null,
      statusToUpdate: null
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    vehicleStatus () {
      return this.vehicle.vehicle_status
    },
    availableStatusChangeOptions () {
      switch (this.vehicleStatus) {
        case 'AT_HQ': return [
          { label: 'In Maintenance', value: 'IN_MAINTENANCE' },
          { label: 'Retire', value: 'RETIRED' }
        ]
        case 'IN_MAINTENANCE': return [
          { label: 'At HQ (Ready)', value: 'AT_HQ' },
          { label: 'Retire', value: 'RETIRED' }
        ]
        case 'RETIRED': return [
          { label: 'At HQ (Ready)', value: 'AT_HQ' },
          { label: 'In Maintenance', value: 'IN_MAINTENANCE' }
        ]
        default: return []
      }
    },
    confirmStatusChangeMessage () {
      return `Change the vehicle status to ${this.statusToUpdate}?`
    }
  },

  methods: {
    // formatDate (date) {
    //   return (date) ? this.$root.utils.dateFormat(date, 'MMMM D, YYYY') : ''
    // },

    cancelStatusChange () {
      this.statusToUpdate = null
    },

    async updateStatus () {
      if (!this.statusToUpdate) return false

      try {
        this.isProcessing = true

        await this.$store.dispatch('sh/dataApi', {
          method: 'post',
          uri: `vehicle/${this.vehicle.id}/status`,
          opts: {
            bodyData: {
              status: this.statusToUpdate
            }
          }
        })

        // Emit event
        this.$emit('updated', { action: 'status-changed' })
      } catch (err) {
        this.processingError = err.message || err.text || err
      } finally {
        this.isProcessing = false
      }
    }
  }
}
</script>

<style>
  .vehicle-status-manager .v-select>.v-input__control>.v-input__slot {
    width: 200px;
  }

  /* .vehicle-status-manager {
    min-height: 100px
  } */

  .vehicle-status-manager.ON_DELIVERY {
    border: 1px solid #8DBF42;
    border-radius: 4px;
  }

  .vehicle-status-manager.IN_MAINTENANCE {
    border: 1px solid #FFD600;
    border-radius: 4px;
  }

  .vehicle-status-manager.AT_HQ, .vehicle-status-manager.RETURNING_TO_HQ {
    border: 1px solid #525252;
    border-radius: 4px;
  }

  .vehicle-status-manager.RETIRED {
    border: 1px solid #FF5D67;
    border-radius: 4px;
  }

  .vehicle-status-manager .action-title {
    font-size: 1.14rem;
    font-weight: 500;
  }

  .vehicle-status-manager .action-info {
    font-size: 1.0rem;
    color: #9c9c9c;
  }
</style>
